module.exports = __webpack_public_path__ + "static/img/son5.86d07a67.jpg";